import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
@Component({
  selector: 'app-appointment-search',
  templateUrl: './appointment-search.component.html',
  styleUrls: ['./appointment-search.component.css']
})
export class AppointmentSearchComponent implements OnInit {

  aptid: any;
  constructor(private router: Router, private spinner: NgxSpinnerService,) { }

  ngOnInit() {
  }

  gotoPage() {
    this.spinner.show();
    this.router.navigate([`/patient/appointment/${this.aptid}`]);
    this.spinner.hide();
  }
}
